import React from 'react'
import { useDispatch } from 'react-redux'
import cn from 'classnames'
import { openModal } from '@/components/composed/Modal/actions'
import { MFO_PAGE_LINK_FORMAT_OPTIONS } from '../../constants'
import './styles.scss'

export const TextWithConsultAction = (text: string) => {
  const dispatch = useDispatch()

  return (
    <span
      onClick={() => dispatch(openModal({ options: { dialogId: 'LandingConsultingModal' } }))}
      className={cn(MFO_PAGE_LINK_FORMAT_OPTIONS.className, 'textWithConsultAction__link')}
    >
      {text}
    </span>
  )
}
